import { render } from "./ListeTypeChambre.vue?vue&type=template&id=6a26855a"
import script from "./ListeTypeChambre.vue?vue&type=script&lang=js"
export * from "./ListeTypeChambre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__